import { tokens } from "@core/theme/tokens";

// Placeholder de ruta (SPEC-201 §alcance: "el contenido real de cada módulo
// de navegación NO es parte de esta SPEC"). Cada módulo reemplaza esto en su
// propia SPEC/implementación.
export function RoutePlaceholder({
  title,
  description,
}: {
  title: string;
  description: string;
}) {
  return (
    <div>
      <h1
        className="display"
        style={{
          fontSize: 34,
          margin: 0,
          color: tokens.text.primary,
          fontFamily: tokens.font.display,
        }}
      >
        {title}
      </h1>
      <div
        style={{
          font: `400 13px ${tokens.font.ui}`,
          color: tokens.text.tertiary,
          marginTop: 6,
          marginBottom: 28,
        }}
      >
        {description}
      </div>
      <div
        style={{
          border: `1px dashed ${tokens.surface.line}`,
          borderRadius: tokens.radius.lg,
          padding: 40,
          textAlign: "center",
          color: tokens.text.disabled,
          font: `500 13px ${tokens.font.ui}`,
        }}
      >
        Módulo pendiente de implementar (SPEC propia).
      </div>
    </div>
  );
}
